<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch"
                    :colSpan="5"
                    :searchBtnColSpan="4" />
                </Col>
            </Row>
        </transition>

        <Card :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">配送单管理</span>
                        <span style="margin-left:10px;">配送时间:</span>
                        <DatePicker type="daterange"
                            v-model="selectDates"
                            size="small"
                            transfer
                            :clearable="false"
                            placement="bottom-end"
                            placeholder="选择期初和期末时间"
                            style=" margin-left:4px;width: 180px"
                            @on-change="onDateChange"></DatePicker>
                        <RadioGroup v-model="saleType"
                            style="margin-left:10px;"
                            @on-change="onSaleTypeChange">
                            <Radio label="Pre"> <span>预售</span></Radio>
                            <Radio label="Cur"> <span>现售</span></Radio>
                        </RadioGroup>
                        <Divider type="vertical" />
                        <RadioGroup v-model="userType"
                            style="margin-left:10px;"
                            @on-change="onUserTypeChange">
                            <Radio label="F"> <span>外部客户</span></Radio>
                            <Radio label="E"> <span>内部客户</span></Radio>
                        </RadioGroup>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getDistributionStationDeliveryList } from "@/api/modules/distributionStation-management/distributionStation-delivery";
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
import { FILE_SERVER } from '@/api/modules/files';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';

export default {
    name: 'DistributionDeliveryList',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            selectDates: [],
            saleType: 'Pre',
            mainTable: {
                tableColumns: [
                    { title: '配送单号', key: 'distributionStationDeliveryRecordCode', width: 180, align: 'center' },
                    { title: '销售单号', key: 'orderCode', width: 160, align: 'center' },
                    { title: '会员编号', key: 'userName', width: 100, align: 'center' },
                    { title: '会员名称', key: 'userPersonName', width: 100, align: 'center' },
                    { title: '商品编号', key: 'productCode', width: 80, align: 'center' },
                    { title: '商品名称', key: 'productName', width: 120, align: 'center' },
                    { title: '物流公司', key: 'distributionStationDeliveryRecordLogisticsCompanyName', width: 120, align: 'center' },
                    { title: '单价', key: 'distributionStationDeliveryPrice', width: 60, align: 'center' },
                    { title: '发货数量', key: 'distributionStationDeliveryQuantity', width: 100, align: 'center' },
                    {
                        title: '发货金额', key: 'deliveryValue', width: 100, align: 'right',
                        render: (h, params) => {
                            const deliveryValue = params.row.deliveryValue ? params.row.deliveryValue : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(deliveryValue, 2, '￥'))
                            ]);
                        }
                    },
                    {
                        title: "配送时间",
                        key: "createAt",
                        width: 140,
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.createAt)
                    },
                    { title: '备注', key: 'distributionStationDeliveryDetailRemark', width: 200, align: 'center' }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '配送单号', type: 'Input', value: '', name: 'distributionStationDeliveryRecordCode', sql: 'like' },
                    { label: '销售单号', type: 'Input', value: '', name: 'orderCode', sql: 'like' },
                    { label: '会员信息', type: 'Input', value: '', name: 'concat(userName,userPersonName)', sql: 'like' },
                    { label: '商品信息', type: 'Input', value: '', name: 'concat(productCode,productName)', sql: 'like' }

                ]
            }
        };
    },
    props: {
        userType: { type: String, default: 'F' }
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        init() {
            this.getMainTableRecords();
        },
        onSaleTypeChange() {
            this.getMainTableRecords(true);
        },
        onUserTypeChange() {
            this.getMainTableRecords(true);
        },
        onDateChange() {
            this.getMainTableRecords(true);
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            if (this.userType) {
                search.globalRemoveFilterConditionKey(this.mainTable.tableSearch, "userType");
                this.mainTable.tableSearch.filters.enable = true;
                this.mainTable.tableSearch.filters.conditions.push({
                    name: 'userType',
                    type: 'eq',
                    value: this.userType
                });
            }
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            this.mainTable.tableSearch.saleType = this.saleType;

            getDistributionStationDeliveryList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    let distributionStationDeliveryQuantityTotal = 0;
                    let deliveryValueTotal = 0;
                    this.mainTable.tableData.forEach(e => {
                        distributionStationDeliveryQuantityTotal += e.distributionStationDeliveryQuantity;
                        deliveryValueTotal += e.deliveryValue;
                    });
                    this.mainTable.tableData.push({
                        distributionStationDeliveryPrice: '本页合计',
                        distributionStationDeliveryQuantity: numberToFixed(distributionStationDeliveryQuantityTotal, 0),
                        deliveryValue: numberToFixed(deliveryValueTotal, 2)
                    });
                    this.mainTable.tableData.push({
                        distributionStationDeliveryPrice: '总合计',
                        distributionStationDeliveryQuantity: numberToFixed(res.data.sumData.sum_distributionStationDeliveryQuantity, 0),
                        deliveryValue: numberToFixed(res.data.sumData.sum_distributionStationDeliveryPrice___distributionStationDeliveryQuantity, 2)
                    });
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>